import { select, take, put, takeEvery } from "redux-saga/effects";
import { push } from "connected-react-router";
import {
  NEW_SEARCH_SUPPORT_ARTICLES_REQUEST,
  NEW_SEARCH_SUPPORT_ARTICLES_RECEIVE,
  NEW_SEARCH_SUPPORT_ARTICLES_FAILURE,
  FETCH_ALL_SUPPORT_DATA_RECEIVE,
  FETCH_ALL_SUPPORT_DATA_FAILURE,
} from "../types/Support";
import { REHYDRATION_COMPLETE } from "../types/App";
import Logger from "../utils/logger";
import { getSupportSearchQuery, getRouter } from "../utils/reduxSelectors";
import { fetchAllSupportDataRequest } from "../actions/SupportActions";

const TAG = "SupportSaga";
const supportUrlPattern = /^(\/support)/i;

const SupportSaga = () => {
  function* worker(action) {
    Logger.d(TAG, `Processing action: ${action.type}`);

    const { location } = yield select(getRouter);

    if (
      action.type === REHYDRATION_COMPLETE &&
      supportUrlPattern.test(location.pathname)
    ) {
      yield put(fetchAllSupportDataRequest());

      const allDataFetchRequest = yield take([
        FETCH_ALL_SUPPORT_DATA_RECEIVE,
        FETCH_ALL_SUPPORT_DATA_FAILURE,
      ]);

      if (allDataFetchRequest.type === FETCH_ALL_SUPPORT_DATA_FAILURE) {
        return Logger.d(
          TAG,
          `Fetching all support data error: ${JSON.stringify(
            allDataFetchRequest.errors
          )}`
        );
      }
    }

    if (action.type === NEW_SEARCH_SUPPORT_ARTICLES_REQUEST) {
      const searchQuery = yield select(getSupportSearchQuery);
      const newSearchResults = yield take([
        NEW_SEARCH_SUPPORT_ARTICLES_RECEIVE,
        NEW_SEARCH_SUPPORT_ARTICLES_FAILURE,
      ]);

      if (newSearchResults.type === NEW_SEARCH_SUPPORT_ARTICLES_FAILURE) {
        return Logger.d(
          TAG,
          `Fetching new search results Error: ${JSON.stringify(
            newSearchResults.errors
          )}`
        );
      }

      // After successful data reception, redirect to /support/search/page/1
      // This should happen when:
      //  1. If not on search results page and do a new search
      //  2. On the search results page and do a new search
      return yield put(
        push({
          pathname: `/support/search/page/${action.pageNum}`,
          search: `q=${searchQuery}`,
        })
      );
    }
  }

  function* watcher() {
    yield takeEvery(
      [NEW_SEARCH_SUPPORT_ARTICLES_REQUEST, REHYDRATION_COMPLETE],
      worker
    );
  }

  return {
    watcher,
    worker,
  };
};

export default SupportSaga;
